<div class="container">
  <div class="page-header">
    <h1 id="userManualH1" i18n="@@user.manual.capture.view.heading1">Anleitungen</h1>
  </div>
  <div class="information" style="margin-bottom: 20px;">
    <span i18n="@@user.manual.info.text">Nachfolgend finden Sie eine Übersicht nützlicher Anleitungen für die Nutzung der Applikation:</span>
    <br>
    <a class="support-link" [href]='userManualUrl'>{{ userManualUrl }}</a>
    <br>
    <br>
    <span i18n="@@support.hint.contact">Bei Fragen oder Problemen wenden Sie sich bitte an den </span> <a class="support-link" [href]="'mailto:' + supportEmail" i18n="@@support.name">Support</a>.
  </div>
</div>
